module.exports = __webpack_public_path__ + "static/media/trave mall shot 4-mobile.5adb71a9.webp";